// Verify
export const DEXF_MAIN_TYPECODE = {
  ARMCHAIR: '00141',
  ARMCHAIR_COMPONENT: '00175',
  CHAISE_LONGUE: '00026',
  COMPONENT: '00164',
  COVER_ITEM: '00062',
  LEG: '00034',
  MATTRESS: '00148',
  SOFA: '00096',
  SOFABED: '00078',
  SOFABED_COMPONENTS: '00165',
} as const

export const DEXF_SUB_TYPECODE = {
  ARMREST_COVER: '31577',
  ARMREST_FRAME: '29759',
  ARMREST_SPR: '10412',
  CHAIR_BED: '23944',
} as const

export const GENERIC_PRODUCT_TYPECODE = {
  COVER: '10072',
  LEGS: '00156',
} as const

export const MEASURE_TYPECODE = {
  DEPTH: '00044',
  FOLDED_OUT: '00580',
  HEIGHT: '00041',
  WIDTH: '00047',
} as const

export const FILTER_ATTRIBUTE_HEADERCODE = {
  color: '38764',
  nbrOfSeats: '38766',
  shape: '38763',
} as const

export const STORAGE_BENEFIT_CODES: string[] = [
  '0039910',
  '0077837',
  '0047189',
  '0091150',
  '0082767',
  '0091157',
  '0059587',
]

/**
 * An array combining the `mainTypeCodes` of sofa, sofa bed and armchair
 */
export const SOFA_MAIN_TYPECODES: string[] = [
  DEXF_MAIN_TYPECODE.ARMCHAIR,
  DEXF_MAIN_TYPECODE.SOFA,
  DEXF_MAIN_TYPECODE.SOFABED,
]
